export const locations = {
  get_all: "accounts/address/",
  create: "accounts/address/",
  update: (id: number) => `accounts/address/?id=${id}`,
  delete: (id: number) => `accounts/address/?id=${id}`,
  get_by_id: (id: number) => `accounts/address/get-by/?id=${id}`,
  countries: "accounts/country/",
  cities: (id: number) => `accounts/city/?id=${id}`,
  geocoding: {
    search: "accounts/geocoding/search/",
    reverse: "accounts/geocoding/reverse/",
    cityBounds: "accounts/geocoding/city-bounds/",
  },
};
